import { addApiPrefix } from 'as-ui-kit/utils/urls';
import {getFetchOptions, handleResult} from 'as-ui-kit/utils/http';
import { snakeToPascalObj } from 'as-ui-kit/utils/adapters';
import { catchWithMsg } from 'utils/http';
import {scrollsInviteDataLimit} from 'consts/scrolls';
const locale = window.getSupportedCulture && window.getSupportedCulture(['ru', 'en']) || 'ru';

const strings = {
    ru: {
        dailyLimitReached: 'Достигнут суточный лимит на действия со списками',
        limitReached: 'Превышен лимит, уменьшите кол-во выбранных фирм и/или списков'
    },
    en: {
        dailyLimitReached: 'Daily limit for actions with lists has been reached',
        limitReached: 'Limit exceeded, reduce the number of selected companies and/or lists'
    }
};

export const createScroll = (scroll, appUrl) =>
    fetch(addApiPrefix('/scrolls/v1/firms/', appUrl), getFetchOptions(scroll, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const getScrolls = (appUrl) =>
    fetch(addApiPrefix('/scrolls/v1/firms/', appUrl))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const inviteToScrolls = (inviteToScrolls, appUrl) => {
    if (inviteToScrolls.length > scrollsInviteDataLimit) {
        window.appErrno?.show({text: strings[locale].limitReached, type: 'warning'});
        return;
    }
    return fetch(addApiPrefix('/scrolls/v1/firms/elements/', appUrl), getFetchOptions(inviteToScrolls, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(err => {
            if (err.error === 'too_many_requests') {
                window.appErrno?.show({text: strings[locale].dailyLimitReached, type: 'warning'});
            } else {
                throw err;
            }
        })
        .catch(catchWithMsg);
};
